// extracted by mini-css-extract-plugin
export default {"box":"Graph_box__xxNn-","header":"Graph_header__Wk9dD"};